<template>
  <div class="record-search" v-loading="loading" element-loading-text="拼命加载中">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回上一层" @click="backIndex"/>
      管网水
    </div>
    <div class="search-input">
      <div class="search-select">
        <el-date-picker
          v-model="startReportDate"
          type="date"
          style="width: 48%"
          placeholder="报告日期-开始"
          format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
          value-format="yyyy-MM-dd"
        />
        <el-date-picker
          v-model="endReportDate"
          type="date"
          style="width: 48%"
          placeholder="报告日期-结束"
          format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
          value-format="yyyy-MM-dd"
        />
      </div>

      <div class="search-btn">
        <button class="btn btn-left" @click="clear">清除内容</button>
        <button class="btn btn-right" @click.prevent="searchRecord(1)">查询记录</button>
      </div>
    </div>

    <div class="search-result warpper" ref="wrapper">
      <ul class="result-content content">
        <li class="result-item" v-for="(item, index) in recordList" :key="index">
          <div class="item-number">样品编号：{{item.sampleNumber}}</div>
          <div class="item-time">采样时间：{{item.samplingDate}} {{item.samplingTime}}</div>
          <div class="item-time">检测日期：{{item.inspectionDate}}</div>
          <div class="item-time">报告日期：{{item.reportDate}}</div>
          <div class="item-entry" v-if="item.status === 0">已完成二次录入：否</div>
          <div class="item-entry" v-if="item.status === 1">已完成二次录入：是</div>
          <div class="item-creator">创建者：{{item.createUserName}}</div>
          <div class="item-btn">
            <el-button
              class="btn btn-left"
              @click="alter(item.id, 1)"
              :disabled="item.status === 1"
            >数据录入</el-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
  data() {
    return {
      popstateLock: 0,//是否监听物理返回键
      loading: false,
      page: 1, // 分页查询，第一次为1
      pullupMsg: '加载更多',
      isShowTips: false,
      startReportDate: null,
      endReportDate: null,
      recordList:[],
      keyword: null,
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.endReportDate) {
            return  time.getTime() > new Date(this.endReportDate).getTime()-8.64e7
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.startReportDate) {
            return  time.getTime() < new Date(this.startReportDate).getTime()-8.64e7
          }
        }
      }
    };
  },
  created() {
    this.searchRecord(0);
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
    this.$nextTick(() => {
      this._initBScroll()
    })
  },
  watch: {
    popstateLock(val) {
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val) {
        this.addPopstate()
      } else {
        this.removePopstate()
      }
    }
  },
  destroyed() {
    this.removePopstate()
  },
  methods: {
    addPopstate() {
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate() {
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 返回上一层
    backIndex() {
      this.$router.push({name: 'hyDataQuery'})
    },
    //修改记录
    alter(id, enter) {
      this.$router.push({name: 'gwsIn', query: {id: id, enter: enter, isCreate: false}});
    },
    clear() {
      if (this.startReportDate || this.endReportDate) {
        this.startReportDate = null;
        this.endReportDate = null;
        this.searchRecord(0);
      }
    },
    searchRecord(valPost) {
      this.page = 1;
      let getStartReportDate = this.$route.query.startReportDate;
      let getEndReportDate = this.$route.query.endReportDate;
      let theStartReportDate = null;
      let theEndReportDate = null;
      if (valPost === 0) {
        if (getStartReportDate) {
          theStartReportDate = getStartReportDate;
          this.startReportDate = getStartReportDate;
        } else {
          theStartReportDate = null;
          this.startReportDate = null;
        }
        if (getEndReportDate) {
          theEndReportDate = getEndReportDate;
          this.endReportDate = getEndReportDate;
        } else {
          theEndReportDate = null;
          this.endReportDate = null;
        }
      } else {
        theStartReportDate = this.startReportDate;
        theEndReportDate = this.endReportDate;
      }
      this.$http.httpGet('/app/laGwWaterInspectionReport/list', {
        startReportDate: theStartReportDate,
        page: 1,
        endReportDate: theEndReportDate,
      }).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          if (res.page.list.length == 0) {
            this.$message.info('查无记录')
          }
          this.recordList = res.page.list
          this.page++
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    _initBScroll() {
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.wrapper, {
          //开启点击事件 默认为false
          click: true,
          scrollY: true,
          probeType: 3
        })
        // 一些监听
        this.scroll.on('scroll', (pos) => {
          if (pos.y - this.scroll.maxScrollY < -50) {
            this.isShowTips = true
          } else {
            this.isShowTips = false
          }
        })

        this.scroll.on('touchEnd', pos => {
          // 1.2.1监听下拉
          if (pos.y >= 50) {
            console.log('下拉刷新')
          }
          // 1.2.2监听上拉
          if (this.scroll.maxScrollY > pos.y + 50) {
            this.loading = true
            this.$http.httpGet('/app/laGwWaterInspectionReport/list', {
              startReportDate: this.startReportDate,
              page: this.page,
              endReportDate: this.endReportDate,
            }).then(res => {
              this.loading = false
              if (res.code === 0 && res.msg === 'success') {
                if (res.page.list.length == 0) {
                  this.$message.info('没有更多数据了')
                  return
                }
                this.page++
                let arr = res.page.list
                this.recordList = this.recordList.concat(arr)
                this.$nextTick(() => {
                  this.scroll.refresh()
                  this.scroll.finishPullUp()
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      } else if (!this.$refs.wrapper) {
        return
      } else {
        this.scroll.refresh()
      }
    },
  },
}
</script>

<style scoped lang="scss">
    //@import '@/assets/style/global.scss';
.record-search {
  margin: 0;
  padding: 50px 0 0;
  position: relative;
  width: 100%;
  .headLine {
    height: 50px;
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 9;
    font-size: 16px;
    border-bottom: 1px #efefef solid;

    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .search-input {
    position: relative;
    margin: 0 0 20px;
    overflow: hidden;

    .search-wrapper {
      position: relative;
      padding: 15px 20px;
      .wrapper-input {
        box-sizing: border-box;
        width: calc(100% - 5rem);
        height: 4rem;
        line-height: 4rem;
        border-radius: 6px 0 0 6px;
        border: 1px solid #ddd;
        background-color: #fff;
        // display: inline-block;
        float: left;

        input {
          height: 3rem;
          width: calc(100% - 2rem);
          border: none;
          padding: 0.5rem 1rem;
          font-size: 1.6rem;
          outline-style: none;
          color: #333;
          background-color: transparent;
        }
      }
      .wrapper-icon {
        position: relative;
        background-color: rgba(245, 209, 7, 0.801);
        width: 5rem;
        height: 4rem;
        display: inline-block;
        line-height: 4rem;
        text-align: center;
        border-radius: 0 6px 6px 0;
        a {
          color: #333;
          i {
            font-size: 3rem;
            font-weight: bold;
          }
        }
      }
    }

    .search-select {
      display: flex;
      justify-content: space-between;
      text-align: center;
      padding: 10px 20px;
      .el-select {
        width: 100%;
      }
    }

    .search-btn {
      margin-top: 0;
      padding: 0 20px;

      button {
        height: 3.2rem;
        font-weight: 700;
        display: inline-block;
        width: 40%;
      }

      .btn-left {
        float: left;
        width: 48%;
        background-color: rgb(207, 0, 0);
      }

      .btn-right {
        float: right;
        width: 48%;
        background-color: rgb(6, 175, 6);
      }
    }
  }

  .search-result {
    position: relative;
    padding: 0;
    height: calc(100vh - 50px - 130px);
    width: 100%;
    // height: 100%;
    overflow: hidden;

    .result-content {
      padding: 0 20px 10px;

      .result-item {
        position: relative;
        overflow: hidden;
        //box-sizing: border-box;
        padding: 10px;
        border-radius: 0.5rem;
        margin-top: 1.6rem;
        /*height: 12rem;*/
        background-color: #f2f6fc;
        color: #303133;
        font-size: 1.6rem;
        box-shadow: 0 0.3rem 0.5rem #eee;

        .item-number,
        .item-time,
        .item-entry,
        .item-creator {
          position: relative;
          margin-bottom: 5px;
          height: 2rem;
          line-height: 2rem;
          font-size: 1.4rem;
          color: #000;
        }

        .item-btn {
          position: relative;
          margin-bottom: 10px;
          //height: 2rem;
          line-height: 2rem;
          font-size: 1.4rem;
          color: #000;

          .el-button {
            //height: 3.2rem;
            font-weight: 700;
            display: inline-block;
            width: 100%;
            background-color: #3A9DF2;
          }
          .btn-left {
            float: left;
          }
          .btn-right {
            float: right;
          }
          .is-disabled {
            background-color: #fff;
          }
        }
      }
    }
  }

  .loading {
    position: fixed;
    bottom: 3rem;
    left: 45%;
    span {
      font-size: 1.4rem;
    }
  }

  .bottom-tip {
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: #333;
    // background: #f2f2f2;
    position: absolute;
    bottom: -5px;
    font-size: 1.6rem;
    left: 0;
  }
}

::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #666;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.el-select-dropdown__item {
  font-size: 14px !important;
  line-height: 34px;
  padding: 0 20px;
}
</style>
